import { State } from '@/store/backstage/state'
import { BackstageInfoResponse } from '@/types/response/BackstageInfoResponse.type'
import { BackstageSessionName, BackstageSessionStatus } from '@/types/BackstageSession.type'
import OT from '@opentok/client'
import { Broadcast } from '@/types/Event.type'

type EditLiveStream = {
    session: 'live' | 'greenroom'
    stream: OT.Stream
}

type SessionStatusUpdate = {
    session: 'live' | 'greenroom'
    status: BackstageSessionStatus
}

type SessionInitied = {
    name: 'live' | 'greenroom'
    session: OT.Session
}

export const ADD_STREAM = (state: State, { session, stream }: EditLiveStream) => {
    const idx = state[session].streams.findIndex(s => s.streamId === stream.streamId)

    if (idx >= 0) {
        state[session].streams.splice(idx, 1, stream)
    } else {
        state[session].streams.push(stream)
    }
}

export const RESET_STREAMS = (state: State) => {
    state['live'].streams = []
    state['greenroom'].streams = []
}

export const REMOVE_STREAM = (state: State, { session, stream }: EditLiveStream) => {
    const idx = state[session].streams.findIndex((s: OT.Stream) => s.streamId === stream.streamId)

    if (idx > -1) {
        state[session].streams.splice(idx, 1)
    }
}

export const SET_BACKSTAGE_INFOS = (state: State, backstageInfos: BackstageInfoResponse) => {
    state.backstageInfos = backstageInfos
}

export const SET_BROADCAST = (state: State, broadcast: Broadcast | null) => {
    state.broadcast = broadcast
}

export const SET_BROWSER_AUDIO_BLOCKED = (state: State, audioBlocked: boolean) => {
    state.browserAudioBlocked = audioBlocked
}

export const SET_AUDIO_VOLUME = (
    state: State,
    {
        session,
        sessionName,
        volume,
    }: {
        session: OT.Session
        sessionName: BackstageSessionName
        volume: number
    }
) => {
    // let session = state[sessionName]?.session
    if (!session) return

    state[sessionName].volume = volume

    state[sessionName].streams
        .map(session.getSubscribersForStream)
        .flat()
        .forEach((subscriber: OT.Subscriber) => subscriber.setAudioVolume(volume))
}

export const SESSION_STATUS_UPDATED = (state: State, { session, status }: SessionStatusUpdate) => {
    state[session].status = status
}

export const SET_INPUT_SOURCE = (state: State, sources: { audio?: OT.Device; video?: OT.Device }) => {
    if (sources.audio !== undefined) {
        state.streamInputSources.audio = sources.audio
    }

    if (sources.video !== undefined) {
        state.streamInputSources.video = sources.video
    }
}

export const SET_TOOLBAR_INPUT = (state: State, sources: { isAudioEnabled: boolean; isVideoEnabled: boolean }) => {
    if (sources.isAudioEnabled !== undefined) {
        state.toolbar.isAudioActivated = sources.isAudioEnabled
    }

    if (sources.isVideoEnabled !== undefined) {
        state.toolbar.isVideoActivated = sources.isVideoEnabled
    }
}

export const ADD_PUBLISHER = (
    state: State,
    { sessionName, publisher }: { sessionName: BackstageSessionName; publisher: OT.Publisher }
) => {
    const idx = state[sessionName].publishers.findIndex(pub => pub.id === publisher.id)

    if (idx >= 0) {
        state[sessionName].publishers.splice(idx, 1, publisher)
    } else {
        state[sessionName].publishers.push(publisher)
    }
}

export const REMOVE_PUBLISHER = (
    state: State,
    { sessionName, publisher }: { sessionName: BackstageSessionName; publisher: OT.Publisher }
) => {
    const idx = state[sessionName].publishers.findIndex(pub => pub?.id === publisher?.id)

    if (idx >= 0) {
        state[sessionName].publishers.splice(idx, 1)
        // publisherToDelete[0].destroy()
    }
}

export const RESET_PUBLISHERS = (state: State, { sessionName }: { sessionName: BackstageSessionName }) => {
    state[sessionName].publishers = []
}

export const INIT_SESSION = (state: State, { name, session }: SessionInitied) => {
    state[name].session = session
}

export const ADD_CONNECTION = (
    state: State,
    { sessionName, connection }: { sessionName: BackstageSessionName; connection: OT.Connection }
) => {
    const idx = state[sessionName].connections.findIndex(conn => conn.connectionId === connection.connectionId)

    if (idx >= 0) {
        state[sessionName].connections.splice(idx, 1, connection)
    } else {
        state[sessionName].connections.push(connection)
    }
}

export const REMOVE_CONNECTION = (
    state: State,
    { sessionName, connection }: { sessionName: BackstageSessionName; connection: OT.Connection }
) => {
    const idx = state[sessionName].connections.findIndex(conn => conn.connectionId === connection.connectionId)

    if (idx > -1) {
        state[sessionName].connections.splice(idx, 1)
    }
}

export const REMOVE_SESSION = (state: State, { sessionName }: { sessionName: BackstageSessionName }) => {
    console.log('REMOVE_SESSION')
    state[sessionName].session = null
    state[sessionName].status = null
    state[sessionName].streams = []
    state[sessionName].connections = []
    state[sessionName].publishers = []
}
